import { Heading } from '@/components/Heading';
import { QuickPay } from '@/components/PaymentButtons/QuickPay';
import { useCheckout } from '@/contexts/checkoutContext';
import { parsePrice } from '@/utils/googlePayPricing';
import * as Styled from './ExpressCheckout.styled';

export const ExpressCheckout = () => {
  const { checkoutData } = useCheckout();
  
  // Check if payment is required (total amount > 0)
  const totalAmount = checkoutData?.amounts?.total ? parsePrice(checkoutData.amounts.total) : null;
  const isPaymentRequired = totalAmount !== null ? totalAmount > 0 : true;
  
  return (
    <Styled.Section>
      <Heading level={2}>Express checkout</Heading>
      {isPaymentRequired ? (
        <QuickPay />
      ) : (
        <Styled.Text>
          No Express Checkout needed — just continue to place your order.
        </Styled.Text>
      )}
    </Styled.Section>
  );
};
